const VIDEO_EXT_REGEX = /\.(mp4|mov|avi|webm|m4v|mkv|quicktime)(\?.*)?$/i;

export const MEDIA_FALLBACK_IMAGE_SRC = '/Musicade-Logo.png';
const MEDIA_FALLBACK_IMAGE_NAME = 'musicade-logo.png';

function sanitizeUrl(url?: string | null): string {
  return typeof url === 'string' ? url.trim() : '';
}

function isFallbackPlaceholderUrl(url?: string | null): boolean {
  const target = sanitizeUrl(url).toLowerCase();
  if (!target) return false;
  return (
    target.endsWith(MEDIA_FALLBACK_IMAGE_NAME) || target.includes(`/${MEDIA_FALLBACK_IMAGE_NAME}`)
  );
}

export function isLikelyVideoUrl(url?: string | null): boolean {
  const target = sanitizeUrl(url);
  if (!target) return false;
  return VIDEO_EXT_REGEX.test(target);
}

export function toDerivedPosterUrl(url?: string | null): string {
  const target = sanitizeUrl(url);
  if (!target || !isLikelyVideoUrl(target)) return '';
  return target.replace(VIDEO_EXT_REGEX, '.png$2');
}

export function resolveVideoPosterUrl(
  mediaUrls?: Array<string | null | undefined>,
  videoPosterUrls?: Array<string | null | undefined> | null,
  preferredIndex = 0,
): string {
  const safeMediaUrls = Array.isArray(mediaUrls) ? mediaUrls : [];
  const safePosterUrls = Array.isArray(videoPosterUrls) ? videoPosterUrls : [];

  const indexPoster = sanitizeUrl(safePosterUrls[preferredIndex]);
  if (indexPoster && !isFallbackPlaceholderUrl(indexPoster)) return indexPoster;

  const firstPoster = sanitizeUrl(safePosterUrls[0]);
  if (firstPoster && !isFallbackPlaceholderUrl(firstPoster)) return firstPoster;

  const sourceUrl = sanitizeUrl(safeMediaUrls[preferredIndex]) || sanitizeUrl(safeMediaUrls[0]);
  const derivedPoster = toDerivedPosterUrl(sourceUrl);
  if (derivedPoster) return derivedPoster;

  const preferredImageUrl = sanitizeUrl(safeMediaUrls[preferredIndex]);
  if (preferredImageUrl && !isLikelyVideoUrl(preferredImageUrl)) return preferredImageUrl;

  const firstImageFallback = safeMediaUrls
    .map((url) => sanitizeUrl(url))
    .find((url) => !!url && !isLikelyVideoUrl(url));
  if (firstImageFallback) return firstImageFallback;

  return MEDIA_FALLBACK_IMAGE_SRC;
}

export function resolvePrimaryMediaUrl(
  mediaUrls?: Array<string | null | undefined>,
  preferredIndex = 0,
): string {
  const safeMediaUrls = Array.isArray(mediaUrls) ? mediaUrls : [];
  const indexed = sanitizeUrl(safeMediaUrls[preferredIndex]);
  if (indexed) return indexed;
  return sanitizeUrl(safeMediaUrls[0]);
}
